import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData, isNil } from 'Utilities/helpers';

import styles from './IconButton.module.scss';

const IconButton = ({ children, className, icon, onClick }) => (
	<button
		className={cx(styles.iconButton, className, { [styles.noClick]: isNil(onClick) })}
		data-testid="icon-button"
		onClick={onClick}
		type="button"
		{...applyCypressData(cypressIds.buttons.savedSearchIcon)}
	>
		{icon}
		{children}
	</button>
);

IconButton.defaultProps = {
	children: null,
	className: '',
	onClick: undefined,
};

IconButton.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	icon: PropTypes.node.isRequired,
	onClick: PropTypes.func,
};

export default IconButton;
